import { useLocation } from 'react-router-dom';

import {
  normalizeCasesFiltersToApiParams,
  CourtSearchPage,
  useClassActionLawsuitSearch,
  useQueryParams,
} from '../shared';
import { type ClassActionSearchResponse } from '../types';

import { ClassActionLawsuitResults } from './ClassActionLawsuitResults';
import {
  ClassActionLawsuitSearchForm,
  type ClassActionLawsuitSearchFormData,
  type ClassActionLawsuitSearchType,
} from './ClassActionLawsuitSearchForm';
import { ClassActionProcessGuideCards } from './ClassActionProcessGuideCards';

const CLASS_ACTION_QUERY_PREFIX_MAP: Record<
  string,
  ClassActionLawsuitSearchType
> = {
  'company:': 'company',
};

export const ClassActionLawsuitSearch = () => {
  const { search } = useLocation();
  const queryParams = useQueryParams(search);
  const query = queryParams.get('query') || '';
  const exactMatchParam = queryParams.get('exact_match');
  const initialExactMatch = exactMatchParam !== 'false';

  const normalizeFilters = (filters: unknown) =>
    normalizeCasesFiltersToApiParams(
      filters as Parameters<typeof normalizeCasesFiltersToApiParams>[0]
    );

  return (
    <CourtSearchPage<
      ClassActionSearchResponse,
      ClassActionLawsuitSearchFormData,
      ClassActionLawsuitSearchType
    >
      queryPrefixMap={CLASS_ACTION_QUERY_PREFIX_MAP}
      normalizeFilters={normalizeFilters}
      useSearchHook={useClassActionLawsuitSearch}
      initialQuery={query}
      initialExactMatch={initialExactMatch}
      SearchForm={ClassActionLawsuitSearchForm}
      ResultsComponent={ClassActionLawsuitResults}
      emptyStateBelowSearchForm={<ClassActionProcessGuideCards />}
    />
  );
};
